"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormModal = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_state_1 = require("../../components/input/input.state");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const spinner_1 = require("../../components/spinner/spinner");
const table_1 = require("../../components/table/table");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const store_1 = require("../../store");
const collection_form_modal_ctrl_1 = require("./collection.form.modal.ctrl");
const collection_form_modal_style_1 = require("./collection.form.modal.style");
(0, theme_1.addStyles)(collection_form_modal_style_1.Style);
class CollectionFormModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.departmentForms = [];
        this.ctrl = new collection_form_modal_ctrl_1.CollectionFormModalCtrl(collections);
        this.errorState = new input_state_1.InputState(i18n_1.T.ERROR);
        this.loadingState = new input_state_1.InputState(i18n_1.T.LOADING);
        this.addState(this.errorState);
        this.addState(this.loadingState);
        store_1.AppStore.FormSummary.refresh();
    }
    get nodes() {
        this.departmentForms = store_1.AppStore.FormSummary.all;
        if (this.departmentForms.length === 0) {
            this.loadingState.setError(i18n_1.T.LOADING);
            return spinner_1.Spinner.view();
        }
        this.loadingState.reset();
        // If warnings exist, show warning UI
        if (this.ctrl.hasWarnings) {
            return this.viewWarning();
        }
        return (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.content }, [this.errorsTable]),
            (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.content }, [this.viewStats()]),
        ]);
    }
    get errorsTable() {
        if (this.ctrl.failures.length === 0) {
            return null;
        }
        const title = (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_ERROR_TITLE, { count: this.ctrl.failures.length });
        const headers = [
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_TITLE),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_REASON),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_NAME),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_VALUE),
        ];
        const rows = [];
        this.ctrl.failures.forEach((error) => {
            let values = '';
            if (error.failure.values) {
                const failure = error.failure;
                values = failure.values.toString();
            }
            const reason = {
                missing: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_MISSING),
                replace: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING),
            };
            rows.push([
                (0, mithril_1.m)('span', { title: error.collectionTitle }, error.collectionTitle),
                (0, mithril_1.m)('span', { title: reason[error.failure.reason] }, reason[error.failure.reason]),
                (0, mithril_1.m)('span', { title: error.failure.fieldName }, error.failure.fieldName ? error.failure.fieldName : error.failure.fieldId),
                (0, mithril_1.m)('span', { title: values }, values),
            ]);
        });
        return table_1.Table.view(title, headers, rows);
    }
    viewStats() {
        const collectionStats = this.ctrl.getCollectionStats(this.departmentForms);
        const title = (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_CONFIRM, { count: this.ctrl.collections.length });
        const headers = [
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_TITLE),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_CURRENT_REVISION),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_LATEST_REVISION),
            (0, i18n_1.Translate)(i18n_1.T.FORM_NAME),
        ];
        const rows = [];
        collectionStats.forEach((stat) => {
            const latestFormDate = stat.latestFormDate ? services_1.Services.DateTime.formatDateTime(stat.latestFormDate) : '';
            const latestFormField = stat.latestFormRevision ? latestFormDate : (0, i18n_1.Translate)(i18n_1.T.FORM_NOT_FOUND);
            const actualFormDate = stat.actualFormDate ? services_1.Services.DateTime.formatDateTime(stat.actualFormDate) : '';
            const actualFormField = stat.latestFormRevision === stat.actualFormRevision
                ? (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_HAS_LATEST_FORM)
                : actualFormDate;
            rows.push([
                (0, mithril_1.m)('span', { title: stat.collectionTitle }, stat.collectionTitle),
                (0, mithril_1.m)('span', { title: actualFormField }, actualFormField),
                (0, mithril_1.m)('span', { title: latestFormField }, latestFormField),
                (0, mithril_1.m)('span', { title: stat.latestFormName }, stat.latestFormName),
            ]);
        });
        return table_1.Table.view(title, headers, rows);
    }
    failToChange() {
        // If warnings were triggered, hide the error notification and don't show error state
        if (this.ctrl.hasWarnings) {
            notification_service_1.NotificationService.hide();
            return;
        }
        this.errorState.setError(i18n_1.T.ERROR);
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.ctrl.updateFormCollections(false);
            // If warnings were detected, switch to warning view and prevent success flow
            if (this.ctrl.hasWarnings) {
                this.displayCustomButtons = true;
                // Throw to prevent success notification and modal close, but this error
                // won't show a notification because we return early from failToChange
                throw new Error('SHOW_WARNING');
            }
        });
    }
    viewWarning() {
        return (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.warningContainer }, [
                (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.warningTitle }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_WARNING_TITLE)),
                (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.warningBody }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_WARNING_BODY)),
                (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.warningList }, [
                    (0, mithril_1.m)('div', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2)),
                    (0, mithril_1.m)('ul', [
                        (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3)),
                        (0, mithril_1.m)('li', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4)),
                    ]),
                ]),
            ]),
            (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.content }, [this.warningsTable]),
            (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.content }, [this.viewStats()]),
        ]);
    }
    get warningsTable() {
        if (this.ctrl.warnings.length === 0) {
            return null;
        }
        const title = (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_WARNING_TABLE_TITLE, { count: this.ctrl.warnings.length });
        const headers = [
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_TITLE),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_REASON),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_NAME),
            (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_VALUE),
        ];
        const rows = [];
        this.ctrl.warnings.forEach((warning) => {
            let values = '';
            if (warning.failure.values) {
                const failure = warning.failure;
                values = failure.values.toString();
            }
            const reason = {
                missing: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_MISSING),
                replace: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING),
            };
            rows.push([
                (0, mithril_1.m)('span', { title: warning.collectionTitle }, warning.collectionTitle),
                (0, mithril_1.m)('span', { title: reason[warning.failure.reason] }, reason[warning.failure.reason]),
                (0, mithril_1.m)('span', { title: warning.failure.fieldName }, warning.failure.fieldName ? warning.failure.fieldName : warning.failure.fieldId),
                (0, mithril_1.m)('span', { title: values }, values),
            ]);
        });
        return table_1.Table.view(title, headers, rows);
    }
    customButtons() {
        return [
            (0, mithril_1.m)('button', {
                className: 'mdl-button',
                onclick: () => this.close(),
                type: 'button',
                disabled: this.loading,
            }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_CANCEL)),
            (0, mithril_1.m)('button', {
                className: 'mdl-button mdl-button--accent',
                onclick: () => this.proceedWithWarnings(),
                type: 'button',
                disabled: this.loading,
            }, this.loading ? spinner_1.Spinner.view() : (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_PROCEED)),
        ];
    }
    proceedWithWarnings() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.setLoading(true);
            try {
                yield this.ctrl.updateFormCollections(true);
                notification_service_1.NotificationService.success(this.ctx.success);
                this.close();
            }
            catch (e) {
                services_1.Logger.error(e);
                notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
                this.setLoading(false);
            }
        });
    }
}
exports.CollectionFormModal = CollectionFormModal;
tslib_1.__decorate([
    mobx_1.computed
], CollectionFormModal.prototype, "errorsTable", null);
tslib_1.__decorate([
    mobx_1.computed
], CollectionFormModal.prototype, "warningsTable", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionFormModal.prototype, "proceedWithWarnings", null);
//# sourceMappingURL=collection.form.modal.js.map